import React from 'react';
import './callToAction.css';
import { NavLink } from "react-router-dom";
const CallToAction = () => {
  return (
    <section className="cta-section">
      <div className="cta-content">
        <h2>Start Building Your Wealth Today</h2>
        <p>Join thousands of users growing their money with smart investing.</p>
        
        <div className="light-line-container">
          <div className="light-line"></div>
          <NavLink to="/getStarted">
                      <button className="cta-btn">
            Get Started Free <span>&gt;</span>
          </button>
          </NavLink>

        </div>
      </div>
    </section>
  );
};

export default CallToAction;
